import {
  BookOpen,
  CircleHelp,
  Home,
  LogOut,
  Search,
  ShieldAlert,
  Sparkles,
} from "lucide-react";
import { NavLink, Outlet, useNavigate } from "react-router";

import { cn } from "../lib/classnames";
import { supabase } from "../lib/supabase";
import { workerDatabase } from "../offline/database";

const links = [
  { to: "/home", label: "Home", icon: Home },
  { to: "/shift", label: "My shift", icon: Sparkles },
  { to: "/guides", label: "Guides", icon: BookOpen },
  { to: "/search", label: "Search", icon: Search },
  { to: "/onboarding", label: "Onboarding", icon: CircleHelp },
  { to: "/emergency", label: "Emergency", icon: ShieldAlert },
];

export function WorkerLayout() {
  const navigate = useNavigate();

  async function signOut() {
    await workerDatabase.purge();
    await supabase.auth.signOut({ scope: "local" });
    void navigate("/login", { replace: true });
  }

  return (
    <div className="min-h-screen pb-24 md:pb-0">
      <header className="border-b border-slate-200 bg-sky-soft">
        <div className="page flex items-center justify-between py-4">
          <NavLink
            to="/home"
            className="min-h-0 text-lg font-extrabold no-underline"
          >
            Teo's Support Hub
          </NavLink>
          <button
            className="button-secondary min-h-0 px-3 py-2 text-sm"
            type="button"
            onClick={() => void signOut()}
          >
            <LogOut size={17} aria-hidden />
            Sign out
          </button>
        </div>
      </header>
      <main id="main-content">
        <Outlet />
      </main>
      <nav
        aria-label="Worker navigation"
        className="fixed inset-x-0 bottom-0 z-20 border-t border-slate-200 bg-white md:static md:border-t-0"
      >
        <div className="mx-auto flex max-w-4xl overflow-x-auto md:justify-center md:gap-3 md:py-3">
          {links.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                cn(
                  "flex min-w-20 flex-1 flex-col items-center justify-center gap-1 px-2 py-2 text-center text-xs font-bold no-underline md:min-h-11 md:flex-none md:flex-row md:rounded-full md:px-4 md:text-sm",
                  isActive ? "bg-sky-soft text-sky-deep" : "text-muted",
                )
              }
            >
              <Icon size={19} aria-hidden />
              {label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
